<bit-form-field>
  <bit-label>{{ "password" | i18n }}</bit-label>
  <input bitInput type="password" [formControl]="password" required appInputVerbatim appAutofocus />
  <bit-hint>{{ "sendProtectedPasswordDontKnow" | i18n }}</bit-hint>
  <button type="button" bitIconButton bitSuffix bitPasswordInputToggle></button>
</bit-form-field>
<div class="tw-flex">
  <button
    bitButton
    bitFormButton
    type="submit"
    buttonType="primary"
    [loading]="loading()"
    [block]="true"
  >
    <span> <i class="bwi bwi-sign-in" aria-hidden="true"></i> {{ "continue" | i18n }} </span>
  </button>
</div>
